/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanPopup from 'vant/es/popup'
import 'vant/es/popup/style/less'


import { render, staticRenderFns } from "./Popup.vue.js?vue&type=template&id=a030f830!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Popup.vue?vue&type=template&id=a030f830"
import script from "./Popup.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Popup.vue?vue&type=script&lang=ts&setup=true"
export * from "./Popup.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Popup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Popup.vue.postcss?vue&type=style&index=0&id=a030f830&prod&lang=postcss!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Popup.vue?vue&type=style&index=0&id=a030f830&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanPopup})
